import { Table } from 'components/table-compat/table-compat'
import { extendWidthsForExtraColumns } from 'utils/table'
import { Container } from 'components/container/Container'
import { usePayrollOvertime } from 'hooks/payroll/overtime'
import { BasicPlaceholder } from 'components/placeholder'
import { buildDataTableObject } from 'utils/data'
import useRefresh from 'hooks/utils/useRefresh'
import { getLocationFilters } from 'utils/api'
import { ErrorAlert } from 'components/error-fallback'
import useCountdown from 'hooks/utils/useCountdown'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import { useEssentials } from 'hooks/utils/useEssentials'
import { translateTableData } from '../../../locales/utils'

export const Overtime = () => {
    const { t, currentLocation, env, logout, session, isEnglish } =
        useEssentials()
    const { payroll } = TRANSLATION_KEYS
    const { overtime } = payroll

    const filters = getLocationFilters(currentLocation)
    let { data, isLoading, isError, refetch, remove, error } =
        usePayrollOvertime({
            env,
            accessToken: session?.accessToken ?? '',
            location: currentLocation,
            filters,
        })
    useRefresh(refetch, remove)
    const count = useCountdown(5, logout, error as Error)

    if (data) {
        data = translateTableData({
            t,
            table: data,
            translation: {
                'week #': payroll.weekNo,
                region_r_number: payroll.payrollRegion,
                'actual %': overtime.actualPct,
                'ly (ad-mapped) %': overtime.lyAdMappedPct,
                'b/(p) to ly (ad-mapped)': overtime.bpTtoLyAdMappedPct,
            },
        })
    }

    if (isLoading) {
        return (
            <div className="placeholder-container" data-testid="placeholder">
                <BasicPlaceholder type="text" rows={1} />
                <BasicPlaceholder type="table" rows={5} columns={3} />
            </div>
        )
    }

    if (isError || !data) {
        return (
            <ErrorAlert error={error} count={count} onRetry={() => refetch()} />
        )
    }

    const baseWidths = isEnglish ? [55, 60, 100, 85] : [65, 65, 105, 150]
    const columnCount = data?.headings?.length ?? baseWidths.length
    const widths = extendWidthsForExtraColumns(baseWidths, columnCount, 100)

    return (
        <Container className="hc8-pt-4x">
            <p className="hc8-fs-050">{t(payroll.overtime.title)}</p>
            <Table
                data={buildDataTableObject({
                    currentData: data,
                    widths,
                    pinFirstColumn: true,
                })}
                scrollableWidth={true}
                className="payroll-overtime-table"
            />
        </Container>
    )
}
